import { FieldDefinition, FieldBuilder, MenuCategories, MenuSubcategories, MENU_CATEGORY_KEY, MENU_SUBCATEGORY_KEY, MENU_NAME_SUFFIX } from '@zendra/shared';

import { SapAccountGroupService } from '../proxy/controlling/controllers/sap-account-group.service';
FieldBuilder.setNamespace('Controlling');

export const SAPACCOUNTSUBGROUP_FIELDS: FieldDefinition[] = [
  FieldBuilder.text('name', 'Entity.SapAccountSubgroup.Name')
    .required()
    .build(),
  FieldBuilder.foreignKey('accountGroupId', 'Entity.SapAccountGroup', SapAccountGroupService)
    .displayFromNested('sapAccountGroup.name')
    .sortBy('sapAccountGroup.name')
    .build(),
];

export const SAPACCOUNTSUBGROUP_CONFIG = {
  entityName: 'SapAccountSubgroup',
  localizationKey: 'Controlling::Entity.SapAccountSubgroup',
  fields: SAPACCOUNTSUBGROUP_FIELDS,
  permission: 'ControllingSap.SapAccountSubgroups',
  showInMenu: true,
  menuCategory: MENU_CATEGORY_KEY + MenuCategories.Controlling + MENU_NAME_SUFFIX,
  menuSubcategory: MENU_SUBCATEGORY_KEY + MenuSubcategories.SAP + MENU_NAME_SUFFIX,
};
